module.exports = __webpack_public_path__ + "img/icon_guanlixitong.33e22bbb.png";